
































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Constants
import Assets from '@/constants/assets.ts';

// Components
import Checkbox, { CheckboxPredefinedStyle } from '@/shared/components/checkbox.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import Input, {
    InputType,
    InputStyle,
} from '@/shared/components/input.component.vue';

// Models
import { Budget } from '@/manager/budget/models/budget.model';
import { Bill } from '@/clickbuy/purchase/models/bill.model';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';

// Services
import UtilsService from '@/core/services/utils.service';

import Dropdown, {
    DropdownWidth,
    DropdownStyle
} from "@/shared/components/Dropdown.component.vue";

import Btn, {
    BtnWidth,
    BtnHeight,
    BtnColor
} from '@/shared/components/btn.component.vue';


@Component({
    components: {
        Checkbox,
        FieldSet,
        Input,
        Dropdown,
        Btn
    },
    computed: {
        ...mapGetters({
            currentBudget: 'getCurrentBudgetAcceptance',
            acceptanceFieldError: 'getAcceptanceFieldError',
            acquiredCourses: 'acquiredCoursesList',
        }),
    },
    methods: {
        ...mapActions({
            setCurrentBudgetAcceptance: 'setCurrentBudgetAcceptance',
        }),
    },
})
export default class BillingData extends Mixins<ErrorMixin>(ErrorMixin) {
    @Prop({ default: false }) private readOnly !: boolean;

    private dropdownWidth = DropdownWidth;
    private DropdownStyle = DropdownStyle;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private btnHeight = BtnHeight;
    private inputType = InputType;
    private checkboxPredefinedStyle = CheckboxPredefinedStyle;
    private currentBudget!: any;
    private setCurrentBudgetAcceptance!: any;
    private acceptanceFieldError!: any;
    private nifMask = '';
    private billNif = '';
    private billFiscalData = true;
    private billingDataCollapsed = true;
    public error: any = {
        bill: {
            name: '',
            email: '',
            nif: '',
            phone: '',
            town: '',
            address: '',
            postalCode: '',
        },
    };
    private literals: any = {
        title: 'Solicitar factura',
        titleReadOnly: 'Datos facturación',
    };
    private productTypeSelected = this.fiscalDataExtensionsList[0];
    private acquiredCourses!: any;
    private isDefaultFiscalData = true;
    private fiscalData = {
        'user': '',
        'email': '',
        'address': '',
        'postalCode': '',
        'town': '',
        'firstName': '',
        'lastName': '',
        'secondLastName': '',
        'nif': '',
        'phone': ' ',
        'id': '',
        'isDefault': false
    };
    private isNewFiscalDataExtension = false;
    private updateFiscalDataExtension = false;
    private currentPurchase: any;

    private created() {
        this.initializeComponent();
    }

    get fiscalDataExtensionsList(): any[] {
        return [
            { nif: 'seleccione' },
            { nif: 'Avenida Gabriel Roca, 8, piso 3' },
            { nif: 'Calle Rafel Rodriguez Mendez, 1, piso 2A' },
        ];
    }

    @Watch("productTypeSelected")
    private watchProductTypeSelected(newVal: any, oldVal: any) {
        this.isNewFiscalDataExtension = false;
        this.isDefaultFiscalData = false;
        this.fiscalData = {
            'user': newVal.userId,
            'email': newVal.email,
            'address': newVal.address,
            'postalCode': newVal.postalCode,
            'town': newVal.town,
            'firstName': newVal.firstName,
            'lastName': newVal.lastName,
            'secondLastName': newVal.secondLastName,
            'nif': newVal.nif,
            'phone': newVal.phone,
            'id': newVal.id,
            'isDefault': false
        }
        this.fillBillData("", true)
        // this.currentPurchase.fiscalData = this.fiscalData;
        // this.currentPurchase.fiscalDataExtensionId = this.fiscalData.id;
        // this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
        // this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
    }

    private updateCurrentFiscalDataExtension() {
        this.updateFiscalDataExtension = true;
        this.readOnly = false;
        let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
        if (this.isDefaultFiscalData) {
            if (defaultExtension.length > 0) {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email,
                    'address': this.acquiredCourses.fiscalData.address,
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'town': this.acquiredCourses.fiscalData.town,
                    'firstName': this.acquiredCourses.fiscalData.firstName,
                    'lastName': this.acquiredCourses.fiscalData.lastName,
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName,
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone,
                    'id': defaultExtension[0].id,
                    "isDefault": true
                }
            } else {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email,
                    'address': this.acquiredCourses.fiscalData.address,
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'town': this.acquiredCourses.fiscalData.town,
                    'firstName': this.acquiredCourses.fiscalData.firstName,
                    'lastName': this.acquiredCourses.fiscalData.lastName,
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName,
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone,
                    'id': '',
                    "isDefault": true
                }
            }
        }
    }

    private patchFiscalDataExtension(data: any, userId: any, id: any) {
        this.updateFiscalDataExtension = false;
        this.readOnly = true;
        // data = {'isDefault': data};
        const payload = {
            id,
            userId,
            data,
        };
        this.$store.dispatch('patchFiscalDataExtension', payload);
        setTimeout(() => {
            // this.fetchFiscalDataExtensionsList();
        }, 1000);
        // 2000
    }

    private patchFiscalDataDefaultExtension(data: any, userId: any, id: any) {
        this.updateFiscalDataExtension = false;
        this.readOnly = true;
        // data = {'isDefault': data};
        data.isDefault = true;
        const payload = {
            id,
            userId,
            data,
        };
        this.$store.dispatch('patchFiscalDataExtension', payload);
        setTimeout(() => {
            // this.fetchFiscalDataExtensionsList();
        }, 1000);
        // 2000
    }

    private newFiscalDataExtension() {
        this.isDefaultFiscalData = false;
        this.isNewFiscalDataExtension = true;
        this.readOnly = false;
        this.fiscalData = {
            'user': this.acquiredCourses.userId,
            'email': '',
            'address': '',
            'postalCode': '',
            'town': '',
            'firstName': '',
            'lastName': '',
            'secondLastName': '',
            'nif': '',
            'phone': ' ',
            'id': '',
            'isDefault': false
        }
    }

    private addFiscalDataExtension(fiscalData: any, status?: any) {
        if (status) {
            fiscalData.isDefault = status
        }
        this.isNewFiscalDataExtension = false;
        this.updateFiscalDataExtension = false;
        this.readOnly = true;
        this.$store.dispatch('newFiscalDataExtension', fiscalData).then(
            res => {
                this.currentPurchase.fiscalData = res;
                this.currentPurchase.fiscalDataExtensionId = res.id;
                this.$store.dispatch("fetchAcquiredCoursesList", { id: fiscalData.user })
                this.$store.dispatch("updateCurrentPurchase", this.currentPurchase);
                this.$store.dispatch("setCurrentPurchase", this.currentPurchase);
            }
        );

    }


    @Watch('billNif')
    private watchNifBill(newVal: string, oldVal: string) {
        this.currentBudget.bill.nif = newVal;
        this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
    }

    @Watch('billFiscalData')
    private watchBillFiscalData(newVal: boolean, oldVal: boolean) {
        this.currentBudget.billFiscalData = newVal;
        if (newVal) {
            this.fillBillData(this.currentBudget);
        } else {
            this.fillBillData();
        }
    }

    @Watch('acceptanceFieldError')
    private watchAcceptanceFieldError(newVal: any, oldVal: any) {
        this.error = Object.assign({}, newVal);
    }


    get billingFormComplete() {
        return (
            this.currentBudget.bill &&
            this.currentBudget.bill.name &&
            this.currentBudget.bill.email &&
            this.currentBudget.bill.phone &&
            this.currentBudget.bill.nif &&
            this.currentBudget.bill.address &&
            this.currentBudget.bill.postalCode &&
            this.currentBudget.bill.town
        );
    }

    get sectionTitle() {
        let title = this.literals.title;
        if (this.readOnly) {
            title = this.literals.titleReadOnly;
        }
        return title;
    }


    private checkSectionBillCollapsed() {
        let collapsed = false;
        if (this.billingDataCollapsed && !this.readOnly && this.billingFormComplete) {
            collapsed = true;
        }
        this.billingDataCollapsed = collapsed;
    }

    private fillBillData(budget: any = new Budget(), isDefault?: any) {
        let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault)[0];

        if (!this.readOnly) {
            if (!isDefault) {
                const firstName = budget.client.user.firstName;
                const lastName = budget.client.user.lastName;
                let completeName = '';
                if (firstName || lastName) {
                    completeName = `${firstName} ${lastName}`;
                }
                this.currentBudget.bill.name = completeName;
                this.currentBudget.bill.email = budget.client.user.email;
                this.currentBudget.bill.nif = budget.client.user.profile.nif;
                this.currentBudget.bill.address = budget.client.user.profile.address;
                this.currentBudget.bill.phone = budget.client.user.profile.phone;
                this.currentBudget.bill.postalCode = budget.client.user.profile.postalCode;
                this.currentBudget.bill.town = budget.client.user.profile.town;

                this.billNif = this.currentBudget.bill.nif;
            } else if (defaultExtension) {
                const firstName = defaultExtension.firstName;
                const lastName = defaultExtension.lastName;
                let completeName = '';
                if (firstName || lastName) {
                    completeName = `${firstName} ${lastName}`;
                }
                this.currentBudget.bill.name = completeName;
                this.currentBudget.bill.email = defaultExtension.email;
                this.currentBudget.bill.nif = defaultExtension.nif;
                this.currentBudget.bill.address = defaultExtension.address;
                this.currentBudget.bill.phone = defaultExtension.phone;
                this.currentBudget.bill.postalCode = defaultExtension.postalCode;
                this.currentBudget.bill.town = defaultExtension.town;

                this.billNif = this.currentBudget.bill.nif;
            } else {
                const firstName = this.fiscalData.firstName;
                const lastName = this.fiscalData.lastName;
                let completeName = '';
                if (firstName || lastName) {
                    completeName = `${firstName} ${lastName}`;
                }
                this.currentBudget.bill.name = completeName;
                this.currentBudget.bill.email = this.fiscalData.email;
                this.currentBudget.bill.nif = this.fiscalData.nif;
                this.currentBudget.bill.address = this.fiscalData.address;
                this.currentBudget.bill.phone = this.fiscalData.phone;
                this.currentBudget.bill.postalCode = this.fiscalData.postalCode;
                this.currentBudget.bill.town = this.fiscalData.town;

                this.billNif = this.currentBudget.bill.nif;
            }
        }
    }

    private updateCurrentBudgetAcceptance() {
        this.setCurrentBudgetAcceptance(this.currentBudget);
    }

    private initializeComponent() {
        this.checkSectionBillCollapsed();

        this.billFiscalData = this.currentBudget.billFiscalData;
        if (this.currentBudget.bill && this.currentBudget.bill.id === '') {
            this.billFiscalData = true;
            // let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
            // this.updateCurrentFiscalDataExtension()
            let defaultExtension = this.acquiredCourses.fiscalDataExtensions.filter((item: any) => item.isDefault);
            if (defaultExtension.length > 0) {
                this.fiscalData = {
                    'user': this.acquiredCourses.userId,
                    'email': this.acquiredCourses.fiscalData.email,
                    'address': this.acquiredCourses.fiscalData.address,
                    'postalCode': this.acquiredCourses.fiscalData.postalCode,
                    'town': this.acquiredCourses.fiscalData.town,
                    'firstName': this.acquiredCourses.fiscalData.firstName,
                    'lastName': this.acquiredCourses.fiscalData.lastName,
                    'secondLastName': this.acquiredCourses.fiscalData.secondLastName,
                    'nif': this.acquiredCourses.fiscalData.nif,
                    'phone': this.acquiredCourses.fiscalData.phone,
                    'id': defaultExtension[0].id,
                    "isDefault": true
                }
                this.fillBillData(this.currentBudget, true);
            } else {
                this.fillBillData(this.currentBudget, false);
            }
        }
        if (this.currentBudget.bill && this.currentBudget.bill.nif !== '') {
            this.billNif = this.currentBudget.bill.nif;
        }
    }
}
